import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { task, timeout } from 'ember-concurrency';
import { later } from '@ember/runloop';
import randomstring from 'randomstring';
import ENV from 'seshy/config/environment';

export default class PlaylistPlayerAbstractComponent extends Component {
  @service session;
  @service stereo;
  @service currentlyPlaying;

  get identifier() {
    let identifiers = [];
    /*
    for (let i = 0, len = this.args.playlist.playlistEntries.length; i < len; i++) {
      let playlistEntry = this.args.playlist.playlistEntries[i];
      let bounce = playlistEntry.project.currentBounce;
      if(bounce){
        identifiers.push(`${bounce.downloadUrl}?Authorization=Bearer ${this.session.data.authenticated.access_token}`);
      }
    }
    */
    //console.log('identifiers = ', identifiers);
    return identifiers;
    //return null;
  }

  get isPlaying() {
    //console.log('calculating is playing')
    let currentlyPlayingPlaylist = this.currentlyPlaying.playlist;
    //console.log('currentlyPlayingPlaylist = ', currentlyPlayingPlaylist);
    if (
      this.stereo.isPlaying &&
      currentlyPlayingPlaylist &&
      currentlyPlayingPlaylist.playlist.id == this.args.playlist.id
    ) {
      return true;
    }
    return false;
  }

  get isPaused() {
    //console.log('calculating is paused')
    let currentlyPlayingPlaylist = this.currentlyPlaying.playlist;
    //console.log('currentlyPlayingPlaylist = ', currentlyPlayingPlaylist);
    if (
      !this.stereo.isPlaying &&
      currentlyPlayingPlaylist &&
      currentlyPlayingPlaylist.playlist.id == this.args.playlist.id
    ) {
      return true;
    }
    return false;
  }

  queuePlaylist() {}

  /*
  playm3u8Playlist(){
    let m3u8Url = `${ENV.api.apihost}/jsonapi/v1/playlists/${this.args.playlist.id}/m3u8.m3u8?Authorization=Bearer ${this.session.data.authenticated.access_token}`
    //console.log('m3u8Url = ', m3u8Url);
    this.stereo.play(m3u8Url, {
      useConnections: ['HLS', 'NativeAudio'],
      //useConnections: ['HLS'],
      metadata: {
        title: this.args.playlist.name,
        artist: 'via Seshy',
        artwork: [{ src: '/images/seshy_robo.png' }],
      },
      xhr: {
        manifestOnly: true, // just send auth headers when requesting the playlist.m3u8, not each segment. not sure how your auth setup is, you might not need this XHR block at all
        headers: this.session.authenticatedHeaders,
      },
    });

    //console.log('stereo.currentSound = ', this.stereo.currentSound)

    later(() => {
      //console.log('stereo.currentSound = ', this.stereo.currentSound)
      //console.log('stereo.currentMetadata = ', this.stereo.currentMetadata)
    }, 2000)

    return;
  }
  */

  togglePlaySoundTask = task(async () => {
    if (this.isPlaying) {
      //console.log('we are playing so we will pause')
      this.stereo.pause();
    } else if (this.isPaused) {
      //console.log('we are paused so we will start playing')
      this.stereo.togglePause();
    } else {
      await this.currentlyPlaying.queuePlaylist(this.args.playlist);
    }
  });

  // TODO: Maybe the currentlyPlaying service should be passed the whole list?
  // And then it manages things and we have a way to know if the playlist itself is currently playing?
  // Not sure....

  oldTogglePlaySoundTask = task(async () => {
    //console.log('calling play for identifiers = ', this.identifier);
    for (
      let i = 0, len = this.args.playlist.playlistEntries.length;
      i < len;
      i++
    ) {
      let playlistEntry = this.args.playlist.playlistEntries[i];
      let bounce = playlistEntry.project.currentBounce;
      await this.currentlyPlaying.queueBounce(bounce);
      //if(bounce){
      //identifiers.push(`${bounce.downloadUrl}?Authorization=Bearer ${this.session.data.authenticated.access_token}`);
      //}
    }
    this.currentlyPlaying.play();
    //this.currentlyPlaying.queueSounds(this.identifier);
    //this.currentlyPlaying.play();
  });
}
